export type LocalRowId = string;

export interface BaseRowState {
  localId: LocalRowId;
  serverId: string | null;
  performedAtDepartmentId: string | null;
  workOrderReference: string | null;
  note: string | null;
  durationMinutes: string;
  expanded: boolean;
  dirty: boolean;
}

export interface NormedRowState extends BaseRowState {
  entryType: "NORMED_WORK";
  productId: string | null;
  operationId: string | null;
  reportedQuantity: string;
  unitId: string | null;
}

export interface NeutralRowState extends BaseRowState {
  entryType: "NEUTRAL_ACTIVITY";
  neutralActivityId: string | null;
}

export interface UnnormedRowState extends BaseRowState {
  entryType: "UNNORMED_WORK";
  operationId: string | null;
  productId: string | null;
  reportedQuantity: string | null;
  unitId: string | null;
}

export type RowState = NormedRowState | NeutralRowState | UnnormedRowState;

export function isNormedRow(row: RowState): row is NormedRowState {
  return row.entryType === "NORMED_WORK";
}
export function isNeutralRow(row: RowState): row is NeutralRowState {
  return row.entryType === "NEUTRAL_ACTIVITY";
}
export function isUnnormedRow(row: RowState): row is UnnormedRowState {
  return row.entryType === "UNNORMED_WORK";
}

let counter = 0;
export function createLocalId(): LocalRowId {
  counter += 1;
  return `local-${Date.now()}-${counter}`;
}

export function emptyNormedRow(): NormedRowState {
  return {
    localId: createLocalId(),
    serverId: null,
    entryType: "NORMED_WORK",
    productId: null,
    operationId: null,
    reportedQuantity: "",
    unitId: null,
    performedAtDepartmentId: null,
    workOrderReference: null,
    note: null,
    durationMinutes: "",
    expanded: false,
    dirty: true,
  };
}

export function emptyNeutralRow(): NeutralRowState {
  return {
    localId: createLocalId(),
    serverId: null,
    entryType: "NEUTRAL_ACTIVITY",
    neutralActivityId: null,
    performedAtDepartmentId: null,
    workOrderReference: null,
    note: null,
    durationMinutes: "",
    expanded: false,
    dirty: true,
  };
}

export function emptyUnnormedRow(): UnnormedRowState {
  return {
    localId: createLocalId(),
    serverId: null,
    entryType: "UNNORMED_WORK",
    operationId: null,
    productId: null,
    reportedQuantity: null,
    unitId: null,
    performedAtDepartmentId: null,
    workOrderReference: null,
    note: null,
    durationMinutes: "",
    expanded: false,
    dirty: true,
  };
}

export interface DraftSnapshot {
  workerId: string;
  workDate: string;
  rows: RowState[];
  savedAt: string;
}
